import { CouponType } from "@reef-os/utils/enums/couponType"

let userPerksMixin = {
    computed: {
        showSmsPromotion() {
			return (
				this.$store.state.user.id != 0 &&
				this.$store.state.user.smsOptIn == 0
			)
		},
        showReferralCampaign() {
            return this.userReferralCoupon != null
        },
        userReferralCoupon() {
            const coupon = this.$store.state.user.coupons.find(
                coupon => coupon.coupon_type == CouponType.REFERRAL
            )
            if (coupon && coupon.code) {
                return coupon.code.toUpperCase()
            }
            return null
        },
        referralCampaignProgress() {
            const campaign = this.$store.state.user.campaigns.find(
                campaign => campaign.campaign.type == 2
            )
            if (campaign) {
                const couponValue = campaign.campaign.parameters.coupon_amount
                return couponValue > 0
                    ? `Refer your neighbors to earn $${couponValue} off!`
                    : null
            }
            return null
        },
        loyaltyCampaign() {
            const campaign = this.$store.state.user.campaigns.find(
                campaign => campaign.campaign.type == 4
            )
            if (campaign) {
                if (campaign && (!campaign.campaign || !campaign.campaign.parameters)) {
                    this.bugsnag.notify("Loyalty Campaign missing data", (event) => {
                        event.addMetadata("campaign", campaign)
                    })
                }
                const ordersNeeded =
                    campaign.progress.goal - campaign.progress.count
                return {
                    amount: campaign.campaign.parameters.coupon_amount,
                    progress: campaign.progress,
                    text: `${ordersNeeded} Orders from your next reward!`
                }
            }
            return null
        }
    },
    methods: {
        getUserPerks() {
            if (this.$store.state.user && this.$store.state.user.id != 0) {
                this.$store.dispatch("getUserCoupons")
                this.$store.dispatch("getUserCampaigns")
            }
        }
    }
}

export default userPerksMixin